<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <!-- <b-col
              cols="12"
              md="5"
              offset-md="1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
              </div>
            </b-col> -->
          </b-row><br>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SEARCH_BY') }}</label>
              <v-select
                v-model="searchBy"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="searchByOptions"
              />
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <div class="d-flex align-items-center justify-content-end">
                <label class="mr-1">{{ $t('DEBTIA_FROM') }}</label>
                <b-input-group class="mr-1">
                  <cleave
                    id="date"
                    v-model="daFromDate"
                    class="form-control"
                    :raw="false"
                    :options="options.date"
                    :placeholder="$t('DEBTIA_FROM')"
                    @input="assignNormalDate($event, 1)"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="fromdate"
                      :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                      trim
                      button-only
                      right
                      size="sm"
                      @input="assignDanishDate($event, 1)"
                    />
                  </b-input-group-append>
                </b-input-group>
                <label class="mr-1">{{ $t('DEBTIA_TILL') }}</label>
                <b-input-group class="mr-1">
                  <cleave
                    id="date"
                    v-model="daTillDate"
                    class="form-control"
                    :raw="false"
                    :options="options.date"
                    :placeholder="$t('DEBTIA_TILL')"
                    @input="assignNormalDate($event, 2)"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="tilldate"
                      :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                      trim
                      button-only
                      right
                      size="sm"
                      @input="assignDanishDate($event, 2)"
                    />
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
          </b-row><br>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="mr-1">{{ $t('DEBTIA_SENT_TO_EMAIL') }}</label>
              <b-form-input
                v-model="receiverEmail"
                class="d-inline-block mr-1"
                :placeholder="$t('DEBTIA_SENT_TO_EMAIL')"
              />
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="mr-1">{{ $t('DEBTIA_SENT_FROM_EMAIL') }}</label>
              <b-form-input
                v-model="senderEmail"
                class="d-inline-block mr-1"
                :placeholder="$t('DEBTIA_SENT_FROM_EMAIL')"
              />
            </b-col>
          </b-row><br>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="mr-1">{{ $t('DEBTIA_SUBJECT') }}</label>
              <b-form-input
                v-model="subject"
                class="d-inline-block mr-1"
                :placeholder="$t('DEBTIA_SUBJECT')"
              />
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="mr-1">{{ $t('DEBTIA_BODY') }}</label>
              <b-form-input
                v-model="body"
                class="d-inline-block mr-1"
                :placeholder="$t('DEBTIA_BODY')"
              />
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          responsive
          :fields="logsFields"
          :items="logsData"
        >
          <template #cell(template)="data">
            {{ data.item.templateName }}
          </template>
          <template #cell(receiver)="data">
            <div v-if="data.item.type === 'sms'">
              {{ data.item.receiver }}
            </div>
            <div v-else>
              {{ getReceiver(data.item.receiver, data.item.type).to }}<br>
              {{ getReceiver(data.item.receiver, data.item.type).cc }}<br>
              {{ getReceiver(data.item.receiver, data.item.type).bcc }}
            </div>
          </template>
          <template #cell(date)="data">
            {{ data.item.createdAt }}
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-b-modal.modal-role
              icon="EyeIcon"
              @click="getLog(data.item)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <logs-modal
          :log-data="showData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getLogs"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BPagination, BFormDatepicker, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import Cleave from 'vue-cleave-component'
import LogsModal from './LogsModal.vue'
// import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BPagination,
    LogsModal,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
    Cleave,
  },
  data() {
    return {
      loader: false,
      logsData: [],
      perPage: 10,
      searchBy: 'All',
      perPageOptions: [10, 25, 50, 100],
      searchByOptions: ['All', 'SMS', 'Email'],
      // searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      showData: {},
      modalLoader: true,
      constants,
      fromdate: '',
      daFromDate: '',
      daTillDate: '',
      tilldate: '',
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
      debounceTimer: null,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      receiverEmail: '',
      senderEmail: '',
      subject: '',
      body: '',
    }
  },
  computed: {
    logsFields() {
      let fields = []
      if (this.user_type === 'Super Admin') {
        fields = [
          { key: 'id', sortable: true },
          { key: 'type', label: i18n.t('DEBTIA_TYPE') },
          { key: 'receiver', label: i18n.t('DEBTIA_RECEIVER') },
          { key: 'apiTokenTitle', label: i18n.t('DEBTIA_API_TOKEN_TITLE') },
          { key: 'companyName', sortable: true, label: i18n.t('DEBTIA_COMPANY_NAME') },
          { key: 'created_at', label: i18n.t('DEBTIA_DATE') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      } else {
        fields = [
          { key: 'id', sortable: true },
          { key: 'type', label: i18n.t('DEBTIA_TYPE') },
          { key: 'receiver', label: i18n.t('DEBTIA_RECEIVER') },
          { key: 'template', label: i18n.t('DEBTIA_TEMPLATE') },
          { key: 'apiTokenTitle', label: i18n.t('DEBTIA_API_TOKEN_TITLE') },
          { key: 'created_at', label: i18n.t('DEBTIA_DATE') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      }
      return fields
    },
  },
  watch: {
    // searchQuery: {
    //   handler() {
    //     clearTimeout(this.debounceTimer)
    //     this.debounceTimer = setTimeout(() => {
    //       this.currentPage = 1
    //       this.getLogs()
    //     }, 200)
    //   },
    // },
    receiverEmail: {
      handler() {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.currentPage = 1
          this.getLogs()
        }, 200)
      },
    },
    senderEmail: {
      handler() {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.currentPage = 1
          this.getLogs()
        }, 200)
      },
    },
    subject: {
      handler() {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.currentPage = 1
          this.getLogs()
        }, 200)
      },
    },
    body: {
      handler() {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.currentPage = 1
          this.getLogs()
        }, 200)
      },
    },
    currentPage: {
      handler() {
        this.getLogs()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getLogs()
      },
    },
    searchBy: {
      handler() {
        this.currentPage = 1
        this.getLogs()
      },
    },
  },
  created() {
    this.getLogs()
  },
  methods: {
    normalToDa(value) {
      const parts = value.split('-')
      const day = Number(parts[2])
      const month = Number(parts[1])
      const year = Number(parts[0])
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
      return formattedDate
    },
    daToNormal(value) {
      let formattedDate = ''
      if (value) {
        const parts = value.split('-')
        const day = Number(parts[0])
        const month = Number(parts[1])
        const year = Number(parts[2])
        formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
      }
      return formattedDate
    },
    validateDate(validatingDate) {
      const regex = /^\d{2}-\d{2}-\d{4}$/
      if (regex.test(validatingDate)) {
        return true
      }
      return false
    },
    assignNormalDate(value, type) {
      if (this.validateDate(value) || !value) {
        if (type === 1) this.fromdate = this.daToNormal(value)
        if (type === 2) this.tilldate = this.daToNormal(value)
        this.currentPage = 1
        if (!this.loader) this.getLogs()
      } else {
        if (type === 1) this.fromdate = this.daToNormal(value)
        if (type === 2) this.tilldate = this.daToNormal(value)
      }
    },
    assignDanishDate(value, type) {
      if (type === 1) this.daFromDate = this.normalToDa(value)
      if (type === 2) this.daTillDate = this.normalToDa(value)
      this.currentPage = 1
      if (!this.loader) this.getLogs()
    },
    getReceiver(item, type) {
      let result = ''
      let cc = ''
      let bcc = ''
      if (type === 'email') {
        const receiver = JSON.parse(item)
        const to = `To: ${receiver.to}`
        if ((receiver.cc).length > 0) {
          cc = `${cc} CC: `
          receiver.cc.forEach((value, i) => {
            const ccItem = `${i !== 0 ? ', ' : ''} ${value}`
            cc = `${cc} ${ccItem}`
          })
        }
        if ((receiver.bcc).length > 0) {
          bcc = `${bcc} BCC: `
          receiver.bcc.forEach((value, i) => {
            const bccItem = `${i !== 0 ? ', ' : ''} ${value}`
            bcc = `${bcc} ${bccItem}`
          })
        }
        const sresult = {
          to, cc, bcc,
        }
        result = sresult
      } else {
        result = item
      }
      // return `Hello${item}`
      return result
    },
    async getLogs() {
      let search = ''
      this.logsData = []
      try {
        this.loader = true
        if (this.searchBy !== 'All') {
          search = this.searchBy
        }
        const url = 'get-logs'
        const logs = await axios.get(`${constants.communicationBaseUrl}template/${url}?receiverEmail=${this.receiverEmail}&senderEmail=${this.senderEmail}&subject=${this.subject}&body=${this.body}&from=${this.fromdate}&to=${this.tilldate}&type=${search}&perPage=${this.perPage}&page=${this.currentPage}`)
        if (logs.status) {
          this.logsData = logs.data.data
          this.totalPages = logs.data.total
          this.from = logs.data.from
          this.to = logs.data.to
          this.currentPage = logs.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getLog(item) {
      this.modalLoader = true
      this.showData = item
      this.modalLoader = false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
